import React, { useState, useEffect, forwardRef } from "react";
import {Grid} from "@material-ui/core";
import PropTypes from 'prop-types';
import { Button } from '../../components/Wrappers'
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import Widget from '../../components/Widget';
import { toast, ToastContainer } from "react-toastify";
import Notification from "../../components/Notification";
import UpdateSite from '../../components/Site/UpdateSite';
const EditSite = forwardRef((props, ref) => {

    const classes = useStyles();
    const [locationState, setLocationState] = useState(props.location.state);
    const [paramsId, setParamsId] = useState(props.match.params.id);
    const [site, setSite] = useState(undefined);


    useEffect(() => {
        let mounted = true;
        const siteId = locationState === undefined ? paramsId : locationState.siteId;
        async function fetchData() {
            const response = await ttAPI.getSiteById(siteId);
            if(mounted){
                setSite(response);
                // if site opens in new tab then change the tab title
                if (response !== undefined && response !== null &&
                    response.name != undefined && response.name !== null &&
                    response.name !== '') {
                    document.title = response.name;
                }

            }
        }

        if (siteId !== undefined && siteId > 0) {
            fetchData();
        }

        return () => mounted = false;
    },[locationState, paramsId]);

    async function refreshSite() {
      setSite(null);
      const response = await ttAPI.getSiteById(site.id);
      setSite(response);
    }


  return (
    <div className={classes.contentDiv}>
      <ToastContainer />

      {site &&
        <Grid container spacing={4}>
            <Grid item xs={12} md={12} sm={12}>
            <Widget title={`Site (Customer: ${site.customer_name})`} disableWidgetMenu>
                <UpdateSite createdSite={site} onUpdateSuccess={refreshSite}/>
                </Widget>
            </Grid>
        </Grid>
      }
    </div>
  );
});
export default EditSite;
